import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { App as CapApp } from "@capacitor/app";
import { Toast } from "@capacitor/toast";

export default function BackButtonHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const exitCount = useRef(0);

  useEffect(() => {
    let backListener;

    const addListener = async () => {
      backListener = await CapApp.addListener("backButton", () => {
        const route = location.pathname;

        if (route === "/login" || route === "/sign-up") {
          CapApp.exitApp();
          return;
        }

        if (route === "/home" || route === "/") {
          exitCount.current++;

          if (exitCount.current === 1) {
            Toast.show({ text: "Press back again to exit" });
            setTimeout(() => {
              exitCount.current = 0;
            }, 2000);
          } else {
            CapApp.exitApp();
          }
          return;
        }

        navigate(-1);
      });
    };

    addListener();

    return () => {
      if (backListener && backListener.remove) {
        backListener.remove();
      }
    };
  }, [location.pathname, navigate]);

  return null;
}
